import { render, staticRenderFns } from "./dietdurationpricedetails.vue?vue&type=template&id=1871df12"
import script from "./dietdurationpricedetails.vue?vue&type=script&lang=js"
export * from "./dietdurationpricedetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports